import { useState, useRef, useEffect} from 'react';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';

const options = [
    {
        actionType: Constant.BOOKMARK_ACTION.EDIT,
        name: '編集'
    },
    {
        actionType: Constant.BOOKMARK_ACTION.DELETE,
        name: '削除'
    },
    {
        actionType: Constant.BOOKMARK_ACTION.SHARE,
        name: '共有する'
    },
    {
        actionType: Constant.BOOKMARK_ACTION.UNSHARE,
        name: '共有を解除'
    }
];

function BookmarkItem({
    bookmark,
    displayEditBookmarkName,
    editBookmarkName,
    handleEditBookmarkName,
    handleSubmitEditBookmarkName,
    editNameError,
    handleDefaultBookmark,
    handleTagBookmark,
    handleBookmarkByActionType,
    displayOptionBookmark,
    setDisplayOptionBookmark,
    shareRangeType,
    isDisplayOptionIcon,
    isDisplayProjectBookmark = true
}) {

    const optionIconRef = useRef(null);
    const optionRef = useRef(null);

    const isDefaultBookmark = (b) => {
        return b.definition === Constant.BOOKMARK_DEFINITION.SYSTEM
            ? Utils.isEmptyString(b.defaultBookmark) : !Utils.isEmptyString(b.defaultBookmark)
    }

    const isDisableAction = actionType => {
        let isDisable = false;
        switch (actionType) {
            case Constant.BOOKMARK_ACTION.UNSHARE:
                isDisable = bookmark.isDeletedCreator || !bookmark.isCanUnshare ? true : false;
                break;
            case Constant.BOOKMARK_ACTION.DELETE:
                isDisable = !bookmark.isCanDelete ? true : false;
                break;
            default:
                break;
        }

        return isDisable;
    };

    return (
        <div key={bookmark.id} className={`bookmark-item-wrapper`}>
            <StartIcon
                className="default-bookmark-icon"
                isDefaultBookmark={isDefaultBookmark(bookmark)}
                onClick={() => handleDefaultBookmark(bookmark)}
            />

            <div className={`bookmark-item-name`}>
                {displayEditBookmarkName === bookmark.id ? (
                    <div className='bookmark-edit-name'>
                        <input
                            className={`
                                bookmark-edit-name-input 
                                ${displayEditBookmarkName === bookmark.id ? `bm-editing-${bookmark.id}` : ''} 
                                ${!Utils.isEmptyString(editNameError) ? 'bookmark-edit-name-input-error' : ''}
                            `}
                            value={editBookmarkName}
                            onChange={e => handleEditBookmarkName(e.target.value)}
                            onKeyUp={e => e.key === "Enter" ? handleSubmitEditBookmarkName(e.target.value, bookmark) : null}
                            onBlur={e => handleSubmitEditBookmarkName(e.target.value, bookmark)}
                        />
                        {!Utils.isEmptyString(editNameError) && <p className='edit-name-error-text'>{editNameError}</p>}
                    </div>
                ) : (
                    <OverFlowTooltipWithTabsMui
                        className={`bookmark-item-name-text ${bookmark.isTagged && 'isTagged'}`}
                        value={bookmark.name}
                        onClick={() => {
                            if (bookmark.isTagged) return;
                            handleTagBookmark(bookmark)
                        }}
                    />
                )}
            </div>
            
            {isDisplayOptionIcon && (
                <>
                    <div
                        ref={optionIconRef}
                        className="bookmark-action-options"
                        onClick={() => setDisplayOptionBookmark(bookmark.id)}
                    >
                        <img
                            src="/assets/image/icon-option-list.svg"
                            alt="icon-option-list"
                            className={`icon-option-list-${bookmark.id}`}
                        />
                    </div>
                    <div
                        ref={optionRef}
                        className={`bookmark-action-list ${displayOptionBookmark === bookmark.id ? 'bm-option-visible' : ''}`}
                    >
                        {options.map((option, i) => {
                            if (option.actionType === Constant.BOOKMARK_ACTION.SHARE && (shareRangeType === Constant.BOOKMARK_PREFIX.PROJECT || !isDisplayProjectBookmark || bookmark.isDeletedCreator)) return <></>
                            if (option.actionType === Constant.BOOKMARK_ACTION.UNSHARE && (shareRangeType === Constant.BOOKMARK_PREFIX.USER)) return <></>

                            let bmActionClassName = `bm-option-action-item`;
                            if (isDisableAction(option.actionType)) {
                                bmActionClassName = `bm-option-action-item disable`;
                            }

                            return (
                                <p
                                    key={i}
                                    className={bmActionClassName}
                                    onClick={() => {
                                        if (isDisableAction(option.actionType)) return;
                                        handleBookmarkByActionType(option.actionType, bookmark)
                                    }}
                                >
                                    {option.name}
                                </p>
                            )
                        })}
                    </div>
                </>
            )}
        </div>
    )
}

export default BookmarkItem;

const StartIcon = ({ isDefaultBookmark = false, className, onClick }) => {
    return (
        <svg
            className={className}
            onClick={onClick}
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.00008 0.166992C6.20192 0.166992 6.38627 0.280922 6.47561 0.460883L7.99097 3.51333L11.3798 4.00583C11.5795 4.03485 11.7453 4.17405 11.8075 4.36493C11.8698 4.55581 11.8177 4.76527 11.6731 4.90528L9.22141 7.2796L9.80001 10.6339C9.83414 10.8317 9.75234 11.0317 9.58902 11.1496C9.4257 11.2676 9.20918 11.2831 9.03052 11.1897L6.00008 9.60514L2.96965 11.1897C2.79098 11.2831 2.57446 11.2676 2.41114 11.1496C2.24782 11.0317 2.16602 10.8317 2.20015 10.6339L2.77875 7.2796L0.327056 4.90528C0.182486 4.76527 0.130372 4.55581 0.192618 4.36493C0.254863 4.17405 0.420678 4.03485 0.620369 4.00583L4.00919 3.51333L5.52456 0.460883C5.6139 0.280922 5.79824 0.166992 6.00008 0.166992Z"
                fill={isDefaultBookmark ? '#FFC000' : '#9096A2'}
            />
        </svg>
    );
};
